import React from 'react';
import PropTypes from 'prop-types';
import Translations from '../../../translation/translation';

function MissingTyreIndex({ onClick }) {
    return (
        <Translations
            translationKey="catalog-statusbar-mobile-missing-status-tyre-index"
            className="statusbar-mobile__missing-status statusbar-mobile__missing-status--tyre-index"
            tagName="div"
            onClick={onClick}
        />
    );
}

MissingTyreIndex.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export { MissingTyreIndex };
